export const createCaptionState = ({ defaultText, savedCaption = null }) => {
    return {
        defaultText,
        savedCaption,
    };
};

export const isCaptionEmpty = (captionEl, defaultText) => {
    const value = captionEl?.textContent?.trim() || '';

    return !value || value === defaultText;
};

export const normaliseSavedCaption = ({
    rawCaption,
    defaultText,
    applyLinkTargets,
}) => {
    if (!rawCaption) {
        return null;
    }

    const textOnly = rawCaption.replace(/<[^>]+>/g, '').trim();

    if (!textOnly || textOnly === defaultText) {
        return null;
    }

    return applyLinkTargets(rawCaption);
};
